import { useUserActionHandlers } from '~/hooks/useUserActionHandlers';
import { EPersistKey } from '~/types/persist';
import { useCallback } from 'react';

export const useSetupGuideState = () => {
  const { actions, setUserActionBy } = useUserActionHandlers({
    persistKey: EPersistKey.SETUP_GUIDE,
  });

  const setupGuideState = actions?.STATUS === 'true';

  const setShowSetupGuide = useCallback(() => setUserActionBy('STATUS', 'true'), [setUserActionBy]);
  const setHideSetupGuide = useCallback(
    () => setUserActionBy('STATUS', 'false'),
    [setUserActionBy],
  );

  return { setupGuideState, setShowSetupGuide, setHideSetupGuide };
};
